module.exports = __webpack_public_path__ + "static/media/pdf.afc44bc7.svg";